export default __webpack_public_path__ + "static/media/myparish.2e9ba0d0.svg";